import {Injectable} from "@angular/core";
import {RouterStateSnapshot, TitleStrategy} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {Title} from "@angular/platform-browser";

@Injectable()
export class CustomPageTitleStrategy extends TitleStrategy {
    constructor(
        private translate: TranslateService,
        private readonly title: Title
    )
    {
        super();
    }

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const title = this.buildTitle(snapshot);
        if (title) {
            this.title.setTitle(`Back Office - ${this.translate.instant(title)}`);
        } else {
            this.title.setTitle('Back Office');
        }
    }
}
